
import { defineStore } from "pinia";
import { pinia } from '..'
import { onBeforeMount, ref } from 'vue'


type TenantName = 'guxiaotui' | 'naiwan' | 'zks'
export const commonStore = defineStore('common', () => {
    const base_url = ref('https://oss.benshutech.com/prod/beauty/')
    const dataBrand = ref('')
    const dataBrandName = ref('')
    const alreadyLoad = ref(false)

    const setDataBrand = (brand: string) => {
        dataBrand.value = brand
    }
    const setDataBrandName = (name: string) => {
        dataBrandName.value = name
    }
    function setFavicon(newIconUrl: string) {
        // 创建新的 link 标签
        var newLink = document.createElement('link');
        newLink.rel = 'icon';
        newLink.type = 'image/x-icon';
        newLink.href = newIconUrl;

        // 获取并移除原有的 favicon link（如果有多个，可能需要更精确的选择器）
        var oldLinks = document.querySelectorAll('link[rel="icon"]') as NodeListOf<HTMLLinkElement>;
        for (var i = 0; i < oldLinks.length; i++) {
            oldLinks[i].parentNode?.removeChild(oldLinks[i]);
        }
        // 将新创建的 link 插入到 head 中
        document.head.appendChild(newLink);
    }
    onBeforeMount(() => {
        const brandHost: { label: string, value: TenantName }[] = [{
            label: '谷小推',
            value: 'guxiaotui'
        }, {
            label: '奈晚',
            value: 'naiwan'
        }, {
            label: '足康树',
            value: 'zks'
        }]
        const hostname = window.location.hostname.split('.')[0] 
        const host = brandHost.find((k) => hostname == k.value)! || brandHost[1]
        setDataBrand(host.value)
        setDataBrandName(host.label)
        setTheme()
        alreadyLoad.value = true
    })
    const setTheme = () => {
        window.document.documentElement.setAttribute('data-brand', dataBrand.value)
        window.document.body.classList.add(dataBrandName.value)
        document.title = dataBrandName.value + '后台管理系统'
        setFavicon(base_url.value + dataBrand.value + '/icon/icon.svg')
    }
    return {
        alreadyLoad,
        base_url,
        dataBrand,
        setDataBrand,
        dataBrandName,
        setDataBrandName,
        setTheme
    }
})

export const useCommonStore = () => {
    return commonStore(pinia)
}

